export const SDN_TEMPLATE = [
  {
    interfaceKey: "YourDemandsAndNeeds",
    title: "Your demands and needs",
    description: "Find insurance that:",
    text: "",
    sdnItems: [
      {
        text: "Allows you to utilise your no claims discount",
        value: false,
      },
      {
        text: "Covers your home against loss or damage",
        value: false,
      },
      {
        text: "Provides additional cover in respect of legal expenses",
        value: false,
      },
      {
        text: "Covers you against accidental damage",
        value: false,
      },
      {
        text: "Offers a range of policy excesses",
        value: false,
      },
      {
        text: "Offers you a competitive premium",
        value: false,
      },
      {
        text: "You can pay monthly or annually",
        value: false,
      },
    ],
  },
  {
    interfaceKey: "SuitabilityReasons",
    title: "Policy suitability",
    description: "This policy:",
    text: "",
    sdnItems: [
      {
        text: "Is competitively priced",
        value: false,
      },
      {
        text: "Offers a variety of payment options",
        value: false,
      },
      {
        text: "Allows you to use the no claims discount you have built up",
        value: false,
      },
      {
        text: "Includes excesses which are acceptable to you",
        value: false,
      },
      {
        text: "Includes Legal Expenses cover",
        value: false,
      },
      {
        text: "Includes Accidental Damage cover",
        value: false,
      },
      {
        text: "Provides suitable cover against loss or damage",
        value: false,
      },
      {
        text: "Meets all of your identified demands and needs",
        value: false,
      },
    ],
  },
  {
    interfaceKey: "DemandsAndNeedsNotMet",
    title: "Demands that have not been met",
    description: "List demands that have not been met",
    text: "",
    sdnItems: [],
  },
  {
    interfaceKey: "WhyPaymentshield",
    title: "Why Paymentshield?",
    description: "Find insurance that:",
    text: "",
    sdnItems: [
      {
        text: "Paymentshield Home Insurance is 5 Star Rated by Defaqto, an independent research company",
        value: false,
      },
      {
        text: "Paymentshield’s Home Insurance is underwritten by a panel of leading insurers",
        value: false,
      },
      {
        text: "Paymentshield has over 25 years’ experience administering general insurance products",
        value: false,
      },
      {
        text: "Paymentshield provide UK based call centres",
        value: false,
      },
    ],
  },
];

export const SDN_TEMPLATE_ADVISED = [
  {
    interfaceKey: "YourDemandsAndNeeds",
    title: "Your demands and needs",
    description: "Find insurance that:",
    additionalText: "",
    questions: [
      {
        id: 0,
        text: "Covers your home against loss or damage",
        reason: "Provides cover for your buildings against loss or damage",
        value: false,
        questions: [
          {
            id: 1,
            text: "Covers your home against accidental damage",
            reason:
              "Includes Accidental Damage cover for your buildings to protect against visible damage which has not been caused on purpose or inevitably",
            value: false,
          },
        ],
      },
      {
        id: 2,
        text: "Covers your contents against loss or damage",
        reason: "Provides cover for your contents against loss or damage",
        value: false,
        questions: [
          {
            id: 3,
            text: "Covers your contents against accidental damage",
            reason:
              "Includes Accidental Damage cover for your contents to protect against visible damage which has not been caused on purpose or inevitably",
            value: false,
          },
          {
            id: 4,
            text: "Covers your personal belongings in or away from the home",
            reason:
              "Includes cover for your Personal Possessions in and away from the home",
            value: false,
          },
        ],
      },
      {
        id: 5,
        text: "Provides additional cover in the event of a home emergency",
        reason:
          "Includes Home Emergency cover to provide assistance following a sudden event that makes the property unsafe, insecure or uninhabitable",
        value: false,
      },
      {
        id: 6,
        text: "Provides additional cover in respect of legal expenses",
        reason:
          "Includes Legal Expenses cover to provide protection for the cost of negotiating or defending your legal rights and to contribute to the loss of wages whilst you are on jury service",
        value: false,
      },
      {
        id: 7,
        text: "Offers a range of policy excesses",
        reason: "Includes excesses which are acceptable to you",
        value: false,
      },
      {
        id: 8,
        text: "You can pay monthly or annually",
        reason: "Offers a variety of payment options",
        value: false,
      },
    ],
  },
];

export const SDN_DATA = [
  {
    interfaceKey: "YourDemandsAndNeeds",
    title: "Your demands and needs",
    description: "Find insurance that:",
    text: "",
    sdnItems: [
      {
        text: "Allows you to utilise your no claims discount",
        value: false,
      },
      {
        text: "Covers your home against loss or damage",
        value: false,
      },
      {
        text: "Provides additional cover in respect of legal expenses",
        value: false,
      },
      {
        text: "Covers you against accidental damage",
        value: false,
      },
      {
        text: "Offers a range of policy excesses",
        value: false,
      },
      {
        text: "Offers you a competitive premium",
        value: false,
      },
      {
        text: "You can pay monthly or annually",
        value: false,
      },
    ],
  },
  {
    interfaceKey: "SuitabilityReasons",
    title: "Policy suitability",
    description: "This policy:",
    text: "",
    sdnItems: [
      {
        text: "Is competitively priced",
        value: false,
      },
      {
        text: "Offers a variety of payment options",
        value: false,
      },
      {
        text: "Allows you to use the no claims discount you have built up",
        value: false,
      },
      {
        text: "Includes excesses which are acceptable to you",
        value: false,
      },
      {
        text: "Includes Legal Expenses cover",
        value: false,
      },
      {
        text: "Includes Accidental Damage cover",
        value: false,
      },
      {
        text: "Provides suitable cover against loss or damage",
        value: false,
      },
      {
        text: "Meets all of your identified demands and needs",
        value: false,
      },
    ],
  },
  {
    interfaceKey: "DemandsAndNeedsNotMet",
    title: "Demands that have not been met",
    description: "List demands that have not been met",
    text: "",
    sdnItems: [],
  },
  {
    interfaceKey: "WhyPaymentshield",
    title: "Why Paymentshield?",
    description: "Find insurance that:",
    text: "",
    sdnItems: [
      {
        text: "Paymentshield Home Insurance is 5 Star Rated by Defaqto, an independent research company",
        value: false,
      },
      {
        text: "Paymentshield’s Home Insurance is underwritten by a panel of leading insurers",
        value: false,
      },
      {
        text: "Paymentshield has over 25 years’ experience administering general insurance products",
        value: false,
      },
      {
        text: "Paymentshield provide UK based call centres",
        value: false,
      },
    ],
  },
];

export const SDN_DATA_LL = [
  {
    interfaceKey: "YourDemandsAndNeeds",
    title: "Your demands and needs",
    description: "Find insurance that:",
    text: "",
    sdnItems: [
      {
        text: "Allows you to utilise your no claims discount",
        value: false,
      },
      {
        text: "Covers your rental property from loss or damage",
        value: false,
      },
      {
        text: "Offers a range of policy excesses",
        value: false,
      },
      {
        text: "Offers a competitive premium",
        value: false,
      },
      {
        text: "Allows you to pay monthly or annually",
        value: false,
      },
      {
        text: "Covers against accidental injury or damage to any person or to their property if you are legally liable as owner of the property",
        value: false,
      },
      {
        text: "Offers Landlords Emergency assistance following a sudden event that makes the property unsafe, insecure or uninhabitable",
        value: false,
      },
    ],
  },
  {
    interfaceKey: "SuitabilityReasons",
    title: "Policy suitability",
    description: "This policy:",
    text: "",
    sdnItems: [
      {
        text: "Is competitively priced",
        value: false,
      },
      {
        text: "Offers a variety of payment options",
        value: false,
      },
      {
        text: "Allows you to use the no claims discount you have built up",
        value: false,
      },
      {
        text: "Includes excesses which are acceptable to you",
        value: false,
      },
      {
        text: "Provides suitable cover against loss or damage",
        value: false,
      },
      {
        text: "Includes liability insurance as part of your cover",
        value: false,
      },
      {
        text: "Meets all of your identified demands and needs",
        value: false,
      },
      {
        text: "Provides Landlords Emergency assistance following a sudden event that makes the property unsafe, insecure or uninhabitable",
        value: false,
      },
    ],
  },
  {
    interfaceKey: "DemandsAndNeedsNotMet",
    title: "Demands that have not been met",
    description: "List demands that have not been met",
    text: "",
    sdnItems: [],
  },
  {
    interfaceKey: "WhyPaymentshield",
    title: "Why Paymentshield?",
    description: "Find insurance that:",
    text: "",
    sdnItems: [
      {
        text: "Paymentshield's Landlords Insurance is 5 Star Rated by Defaqto, an independent research company",
        value: false,
      },
      {
        text: "Paymentshield's Landlords Insurance is underwritten by a panel of leading insurers",
        value: false,
      },
      {
        text: "Paymentshield has over 25 years’ experience administering general insurance products",
        value: false,
      },
      {
        text: "Paymentshield provide UK based call centres",
        value: false,
      },
    ],
  },
];

export const SDN_DATA_ADVISED = [
  {
    interfaceKey: "YourDemandsAndNeeds",
    title: "Your demands and needs",
    description: "Find insurance that:",
    additionalText: "",
    questions: [
      {
        id: 0,
        text: "Covers your home against loss or damage",
        reason: "Provides cover for your buildings against loss or damage",
        value: false,
        questions: [
          {
            id: 1,
            text: "Covers your home against accidental damage",
            reason:
              "Includes Accidental Damage cover for your buildings to protect against visible damage which has not been caused on purpose or inevitably",
            value: false,
          },
        ],
      },
      {
        id: 2,
        text: "Covers your contents against loss or damage",
        reason: "Provides cover for your contents against loss or damage",
        value: false,
        questions: [
          {
            id: 3,
            text: "Covers your contents against accidental damage",
            reason:
              "Includes Accidental Damage cover for your contents to protect against visible damage which has not been caused on purpose or inevitably",
            value: false,
          },
          {
            id: 4,
            text: "Covers your personal belongings in or away from the home",
            reason:
              "Includes cover for your Personal Possessions in and away from the home",
            value: false,
          },
        ],
      },
      {
        id: 5,
        text: "Provides additional cover in the event of a home emergency",
        reason:
          "Includes Home Emergency cover to provide assistance following a sudden event that makes the property unsafe, insecure or uninhabitable",
        value: false,
      },
      {
        id: 6,
        text: "Provides additional cover in respect of legal expenses",
        reason:
          "Includes Legal Expenses cover to provide protection for the cost of negotiating or defending your legal rights and to contribute to the loss of wages whilst you are on jury service",
        value: false,
      },
      {
        id: 7,
        text: "Offers a range of policy excesses",
        reason: "Includes excesses which are acceptable to you",
        value: false,
      },
      {
        id: 8,
        text: "You can pay monthly or annually",
        reason: "Offers a variety of payment options",
        value: false,
      },
    ],
  },
];

export const SDN_DATA_ADVISED_LL = [
  {
    interfaceKey: "YourDemandsAndNeeds",
    title: "Your demands and needs",
    description: "Find insurance that:",
    additionalText: "",
    questions: [
      {
        id: 0,
        text: "Covers your rental property against loss or damage",
        reason:
          "Includes cover for your rental property against loss or damage",
        value: false,
        questions: [
          {
            id: 1,
            text: "Covers your rental property against accidental damage",
            reason:
              "Includes Accidental Damage cover to protect your rental property against visible damage which has not been caused on purpose or inevitably",
            value: false,
          },
        ],
      },
      {
        id: 2,
        text: "Provides cover for loss or damage to domestic furniture and furnishings which belong to you and are in the insured property",
        reason:
          "Includes cover for loss or damage to domestic furniture and furnishings which belong to you and are in the insured property",
        value: false,
        questions: [
          {
            id: 3,
            text: "Covers domestic furniture and furnishings which belong to you and are in the insured property against accidental damage",
            reason:
              "Includes Accidental Damage cover to protect your domestic furniture and furnishings against visible damage which has not been caused on purpose or inevitably",
            value: false,
          },
        ],
      },
      {
        id: 4,
        text: "Offers Landlords Emergency assistance following a sudden event that makes the property unsafe, insecure or uninhabitable",
        reason:
          "Provides Landlords Emergency assistance following a sudden event that makes the property unsafe, insecure or uninhabitable",
        value: false,
      },
      {
        id: 5,
        text: "Offers Legal Expenses protection for the cost of negotiating or defending your legal rights",
        reason:
          "Provides Legal Expenses protection for the cost of negotiating or defending your legal rights and to contribute to the loss of wages whilst you are on jury service",
        value: false,
      },
      {
        id: 6,
        text: "Offers Rent Protection cover to assist with eviction of a tenant and to recuperate lost rental payments",
        reason:
          "Provides Rent Protection cover to assist with eviction of a tenant and to recuperate lost rental payments",
        value: false,
      },
      {
        id: 7,
        text: "Offers a range of policy excesses",
        reason: "Includes excesses which are acceptable to you",
        value: false,
      },
      {
        id: 8,
        text: "You can pay monthly or annually",
        reason: "Offers a variety of payment options",
        value: false,
      },
    ],
  },
];

export const SDN_DATA_TC = [
  {
    interfaceKey: "YourDemandsAndNeeds",
    title: "Your demands and needs",
    description: "Find insurance that:",
    text: "",
    sdnItems: [
      {
        text: "Adequately covers you and the household’s contents in the home",
        value: false,
      },
      {
        text: "Allows you to utilise your no claims discount",
        value: false,
      },
      {
        text: "Covers you against accidental damage to your landlord’s belongings and the property",
        value: false,
      },
      {
        text: "Provides cover in respect of legal expenses",
        value: false,
      },
      {
        text: "Protects items that are normally worn or carried away from the home",
        value: false,
      },
      {
        text: "Covers you and the household against accidental damage to your contents",
        value: false,
      },
      {
        text: "Offers a range of policy excesses",
        value: false,
      },
    ],
  },
  {
    interfaceKey: "SuitabilityReasons",
    title: "The reasons why the policy/policies is/are considered suitable",
    shortTitle: "Policy suitability",
    description: "This policy:",
    text: "",
    sdnItems: [
      {
        text: "Includes cover for your contents when in the home",
        value: false,
      },
      {
        text: "Allows you to utilise the no claims discount you have built up",
        value: false,
      },
      {
        text: "Includes cover for accidental damage you cause to your landlord’s belongings and the property",
        value: false,
      },
      {
        text: "Includes tenants legal expenses cover",
        value: false,
      },
      {
        text: "Includes cover for items that are normally worn or carried away from the home",
        value: false,
      },
      {
        text: "Includes upgraded accidental damage cover for your contents",
        value: false,
      },
      {
        text: "Includes excesses that are acceptable to you",
        value: false,
      },
    ],
  },
  {
    interfaceKey: "DemandsAndNeedsNotMet",
    title: "Demands that have not been met",
    description: "List demands that have not been met",
    text: "",
    sdnItems: [],
  },
  {
    interfaceKey: "WhyPaymentshield",
    title: "Why Paymentshield?",
    description: "",
    text: "",
    sdnItems: [
      {
        text: "Paymentshield’s Tenants Contents Insurance is underwritten by a panel of insurers",
        value: false,
      },
      {
        text: "Paymentshield have over 30 years’ experience administering general insurance products",
        value: false,
      },
    ],
  },
];

export const SDN_DATA_ADVISED_TC = [
  {
    interfaceKey: "YourDemandsAndNeeds",
    title: "Your demands and needs",
    description: "Find insurance that:",
    additionalText: "",
    questions: [
      {
        id: 0,
        text: "Adequately covers you and the household’s contents in the home",
        reason: "Includes cover for your contents when in the home",
        value: false,
      },
      {
        id: 1,
        text: "Allows you to utilise your no claims discount",
        reason:
          "Allows you to utilise the no claims discount you have built up",
        value: false,
      },
      {
        id: 2,
        text: "Covers you against accidental damage to your landlord’s belongings and the property",
        reason:
          "Includes cover for accidental damage you cause to your landlord’s belongings and the property",
        value: false,
      },
      {
        id: 3,
        text: "Provides cover in respect of legal expenses",
        reason: "Includes tenants legal expenses cover",
        value: false,
      },
      {
        id: 4,
        text: "Protects items that are normally worn or carried away from the home",
        reason:
          "Includes cover for items that are normally worn or carried away from the home",
        value: false,
      },
      {
        id: 5,
        text: "Covers you and the household against accidental damage to your contents",
        reason: "Includes upgraded accidental damage cover for your contents",
        value: false,
      },
      {
        id: 6,
        text: "Offers a range of policy excesses",
        reason: "Includes excesses that are acceptable to you",
        value: false,
      },
    ],
  },
  {
    interfaceKey: "WhyPaymentshield",
    title: "Why Paymentshield?",
    description: "",
    additionalText: "",
    questions: [
      {
        id: 0,
        text: "Paymentshield’s Tenants Contents Insurance is underwritten by a panel of insurers",
        value: false,
      },
      {
        id: 1,
        text: "Paymentshield have over 30 years’ experience administering general insurance products",
        value: false,
      },
    ],
  },
];

export const SDN_DATA_MPPI = [
  {
    interfaceKey: "YourDemandsAndNeeds",
    title: "Your demands and needs",
    description: "To:",
    shortTitle: "Your demands and needs",
    text: "",
    sdnItems: [
      {
        id: 1,
        text: "Obtain a competitive premium",
        value: false,
        displayRules: null,
      },
      {
        id: 2,
        text: "Take out a monthly contract",
        value: false,
        displayRules: null,
      },
      {
        id: 3,
        text: "Pay for the cover monthly",
        value: false,
        displayRules: null,
      },
      {
        id: 4,
        text: "Have sufficient protection to maintain your mortgage repayments in the event of you becoming involuntarily unemployed or suffering an accident or sickness (also known as a disability)",
        value: false,
        displayRules: [
          {
            type: "Accident, sickness and unemployment",
            benefitPeriod: null,
            disabilityQualificationPeriod: null,
            disabilityQualificationType: null,
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
        ],
      },
      {
        id: 5,
        text: "Have sufficient protection to maintain your mortgage repayments in the event of you suffering an accident or sickness (also known as a disability)",
        value: false,
        displayRules: [
          {
            type: "Accident and sickness",
            benefitPeriod: null,
            disabilityQualificationPeriod: null,
            disabilityQualificationType: null,
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
        ],
      },
      {
        id: 6,
        text: "Have any claims payments for accident or sickness back dated to the first day of claim",
        value: false,
        displayRules: [
          {
            type: "Accident and sickness",
            benefitPeriod: null,
            disabilityQualificationPeriod: null,
            disabilityQualificationType: "Back to Day 1",
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
          {
            type: "Accident, sickness and unemployment",
            disabilityQualificationPeriod: null,
            disabilityQualificationType: "Back to Day 1",
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
        ],
      },
      {
        id: 7,
        text: "Have any claims payments for unemployment back dated to the first day of claim",
        value: false,
        displayRules: [
          {
            type: "Accident, sickness and unemployment",
            disabilityQualificationPeriod: null,
            disabilityQualificationType: null,
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: "Back to Day 1",
          },
        ],
      },
      {
        id: 8,
        text: "Have any claims payments for unemployment paid after an initial excess period in order to minimise the monthly premium",
        value: false,
        displayRules: [
          {
            type: "Accident, sickness and unemployment",
            disabilityQualificationPeriod: null,
            disabilityQualificationType: null,
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: "Excess",
          },
        ],
      },
      {
        id: 9,
        text: "Have any claims payments for accident or sickness paid after an initial excess period in order to minimise the monthly premium",
        value: false,
        displayRules: [
          {
            type: "Accident, sickness and unemployment",
            benefitPeriod: null,
            disabilityQualificationPeriod: null,
            disabilityQualificationType: "Excess",
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
          {
            type: "Accident and sickness",
            disabilityQualificationPeriod: null,
            disabilityQualificationType: "Excess",
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
        ],
      },
      {
        id: 10,
        text: "Have sufficient protection to maintain your mortgage repayments in the event of you becoming involuntarily unemployed",
        value: false,
        displayRules: [
          {
            type: "Accident, sickness and unemployment",
            benefitPeriod: null,
            disabilityQualificationPeriod: null,
            disabilityQualificationType: null,
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
        ],
      },
    ],
  },
  {
    interfaceKey: "SuitabilityReasons",
    title: "The reason why the policy/ policies is/are considered suitable",
    shortTitle: "Policy suitability",
    description: "This policy:",
    text: "",
    sdnItems: [
      {
        id: 11,
        text: "Is a competitively priced product",
        value: false,
        displayRules: null,
      },
      {
        id: 12,
        text: "Is a monthly policy with premiums being collected by monthly Direct Debit",
        value: false,
        displayRules: null,
      },
      {
        id: 13,
        text: "Provides cover subject to your unemployment lasting for at least 30 days. The benefit is paid monthly in arrears making the first payment due on the 31st day",
        value: false,
        displayRules: [
          {
            type: "Accident, sickness and unemployment",
            benefitPeriod: null,
            disabilityQualificationPeriod: null,
            disabilityQualificationType: null,
            unemploymentQualificationPeriod: "30 days",
            unemploymentQualificationType: "Back to Day 1",
          },
        ],
      },
      {
        id: 14,
        text: "Provides cover subject to your disability lasting for at least 30 days. The benefit is paid monthly in arrears making the first payment due on the 31st day",
        value: false,
        displayRules: [
          {
            type: "Accident and sickness",
            benefitPeriod: null,
            disabilityQualificationPeriod: "30 days",
            disabilityQualificationType: "Back to Day 1",
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
          {
            type: "Accident, sickness and unemployment",
            benefitPeriod: null,
            disabilityQualificationPeriod: "30 days",
            disabilityQualificationType: "Back to Day 1",
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
        ],
      },
      {
        id: 15,
        text: "Provides cover subject to your disability lasting for at least 60 days. The benefit is paid monthly in arrears making the first payment due on the 61st day",
        value: false,
        displayRules: [
          {
            type: "Accident and sickness",
            benefitPeriod: null,
            disabilityQualificationPeriod: "60 days",
            disabilityQualificationType: "Back to Day 1",
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
          {
            type: "Accident, sickness and unemployment",
            benefitPeriod: null,
            disabilityQualificationPeriod: "60 days",
            disabilityQualificationType: "Back to Day 1",
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
        ],
      },
      {
        id: 16,
        text: "Provides cover subject to your unemployment lasting for at least 60 days. The benefit is paid monthly in arrears making the first payment due on the 61st day",
        value: false,
        displayRules: [
          {
            type: "Accident, sickness and unemployment",
            benefitPeriod: null,
            disabilityQualificationPeriod: null,
            disabilityQualificationType: null,
            unemploymentQualificationPeriod: "60 days",
            unemploymentQualificationType: "Back to Day 1",
          },
        ],
      },
      {
        id: 17,
        text: "Provides disability cover subject to a 30 day excess period before you are eligible for any claims benefit.  Benefit becomes due from the 31st day and is paid monthly in arrears, meaning the first payment is made on the 61st day",
        value: false,
        displayRules: [
          {
            type: "Accident and sickness",
            benefitPeriod: null,
            disabilityQualificationPeriod: "30 days",
            disabilityQualificationType: "Excess",
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
          {
            type: "Accident, sickness and unemployment",
            benefitPeriod: null,
            disabilityQualificationPeriod: "30 days",
            disabilityQualificationType: "Excess",
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
        ],
      },
      {
        id: 18,
        text: "Provides unemployment cover subject to a 30 day excess period before you are eligible for any claims benefit.  Benefit becomes due from the 31st day and is paid monthly in arrears, meaning the first payment is made on the 61st day",
        value: false,
        displayRules: [
          {
            type: "Accident, sickness and unemployment",
            benefitPeriod: null,
            disabilityQualificationPeriod: null,
            disabilityQualificationType: null,
            unemploymentQualificationPeriod: "30 days",
            unemploymentQualificationType: "Excess",
          },
        ],
      },
      {
        id: 19,
        text: "Provides unemployment cover subject to a 60 day excess period before you are eligible for any claims benefit.  Benefit becomes due from the 61st day and is paid monthly in arrears, meaning the first payment is made on the 91st day",
        value: false,
        displayRules: [
          {
            type: "Accident, sickness and unemployment",
            benefitPeriod: null,
            disabilityQualificationPeriod: null,
            disabilityQualificationType: null,
            unemploymentQualificationPeriod: "60 days",
            unemploymentQualificationType: "Excess",
          },
        ],
      },
      {
        id: 20,
        text: "Provides disability cover subject to a 60 day excess period before you are eligible for any claims benefit.  Benefit becomes due from the 61st day and is paid monthly in arrears, meaning the first payment is made on the 91st day",
        value: false,
        displayRules: [
          {
            type: "Accident and sickness",
            benefitPeriod: null,
            disabilityQualificationPeriod: "60 days",
            disabilityQualificationType: "Excess",
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
          {
            type: "Accident, sickness and unemployment",
            benefitPeriod: null,
            disabilityQualificationPeriod: "60 days",
            disabilityQualificationType: "Excess",
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
        ],
      },
      {
        id: 21,
        text: "Provides disability cover subject to a 180 day excess period before you are eligible for any claims benefit.  Benefit becomes due from the 181st day and is paid monthly in arrears, meaning the first payment is made on the 211th day",
        value: false,
        displayRules: [
          {
            type: "Accident and sickness",
            benefitPeriod: null,
            disabilityQualificationPeriod: "180 days",
            disabilityQualificationType: "Excess",
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
          {
            type: "Accident, sickness and unemployment",
            benefitPeriod: null,
            disabilityQualificationPeriod: "180 days",
            disabilityQualificationType: "Excess",
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
        ],
      },
      {
        id: 22,
        text: "Provides unemployment cover subject to a 180 day excess period before you are eligible for any claims benefit.  Benefit becomes due from the 181st day and is paid monthly in arrears, meaning the first payment is made on the 211th day",
        value: false,
        displayRules: [
          {
            type: "Accident, sickness and unemployment",
            benefitPeriod: null,
            disabilityQualificationPeriod: null,
            disabilityQualificationType: null,
            unemploymentQualificationPeriod: "180 days",
            unemploymentQualificationType: "Excess",
          },
        ],
      },
      {
        id: 23,
        text: "Meets all of your identified demands and needs",
        value: false,
        displayRules: null,
      },
    ],
  },
  {
    interfaceKey: "WhyPaymentshield",
    title: "Why Paymentshield?",
    shortTitle: "Why Paymentshield?",
    description: "",
    text: "",
    sdnItems: [
      {
        id: 24,
        text: "Paymentshield's products are rated by Defaqto. Defaqto is an independent financial research company in the UK",
        value: false,
        displayRules: null,
      },
      {
        id: 25,
        text: "Over 20 years experience administering general insurance products",
        value: false,
        displayRules: null,
      },
      {
        id: 26,
        text: "UK based call centres",
        value: false,
        displayRules: null,
      },
      {
        id: 27,
        text: "Paymentshield have selected a specialist insurance provider for this cover",
        value: false,
        displayRules: null,
      },
      {
        id: 28,
        text: "Nominated claims handlers if you should need to claim",
        value: false,
        displayRules: null,
      },
    ],
  },
  {
    interfaceKey: "Recommendation",
    title: "The Recommendation",
    shortTitle:
      "I recommend that you take out the above policy/policies which:",
    text: "",
    sdnItems: [
      {
        id: 29,
        text: "Provides cover if you are unable to work due to unemployment or a disability",
        value: false,
        displayRules: [
          {
            type: "Accident, sickness and unemployment",
            benefitPeriod: null,
            disabilityQualificationPeriod: null,
            disabilityQualificationType: null,
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
        ],
      },
      {
        id: 30,
        text: "Provides cover if you are unable to work due to a disability",
        value: false,
        displayRules: [
          {
            type: "Accident and sickness",
            benefitPeriod: null,
            disabilityQualificationPeriod: null,
            disabilityQualificationType: null,
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
        ],
      },
      {
        id: 31,
        text: "Enables you to continue to meet part or all of the mortgage repayments for up to 12 months",
        value: false,
        displayRules: [
          {
            type: "Accident and sickness",
            benefitPeriod: "12 months",
            disabilityQualificationPeriod: null,
            disabilityQualificationType: null,
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
          {
            type: "Accident, sickness and unemployment",
            benefitPeriod: "12 months",
            disabilityQualificationPeriod: null,
            disabilityQualificationType: null,
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
        ],
      },
      {
        id: 32,
        text: "Enables you to continue to meet part or all of the mortgage repayments for up to 24 months in any one period of claim",
        value: false,
        displayRules: [
          {
            type: "Accident and sickness",
            benefitPeriod: "24 months",
            disabilityQualificationPeriod: null,
            disabilityQualificationType: null,
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
          {
            type: "Accident, sickness and unemployment",
            benefitPeriod: "24 months",
            disabilityQualificationPeriod: null,
            disabilityQualificationType: null,
            unemploymentQualificationPeriod: null,
            unemploymentQualificationType: null,
          },
        ],
      },
      {
        id: 33,
        text: "Based upon the above you have accepted my recommendations.",
        value: false,
        displayRules: null,
      },
    ],
  },
  {
    interfaceKey: "DemandsAndNeedsNotMet",
    title: "Demands that have not been met",
    text: "",
    sdnItems: [],
  },
];
